module.exports = __webpack_public_path__ + "media/images/countryrect/mm-c791388214d1f14a1d5b5d97a62012ad.svg";